import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../../common/components/icons';
import { sizeEnum } from '../../../../common/components/icons/Icon';

const TransferredIcon = ({ transferredAt }) => {
  if (!transferredAt) return null;
  return <Icon icon="cloud_upload" size={sizeEnum.small} />;
};

TransferredIcon.propTypes = {
  transferredAt: PropTypes.string,
};

TransferredIcon.defaultProps = {
  transferredAt: undefined,
};

export default TransferredIcon;
